import React from 'react';
import programStatuses from 'data/program_statuses';
import RowActions from './RowActions';

export default [
  {
    name: 'Name',
    selector: (row) => row.attributes.title,
    sortable: true,
    searchable: true,
    width: '300px',
  },
  {
    name: 'Assigned On',
    selector: (row) => row.attributes.assigned_on,
    sortable: true,
    searchable: true,
    width: '300px',
  },
  {
    name: 'Status',
    selector: (row) => programStatuses.find((item) => item.value === row.attributes.status).label,
    sortable: true,
    searchable: true,
  },
  {
    name: 'Actions',
    sortable: false,
    width: '100px',
    right: true,
    cell: (row) => <RowActions row={row} />,
  },
];
